import { type ReactNode } from 'react';
import { X, Youtube, Video } from 'lucide-react';

const YT_RX =
  /(?:youtube\.com\/(?:watch\?v=|shorts\/|embed\/)|youtu\.be\/)([\w-]{11})/i;
const LOOM_RX = /loom\.com\/(?:share|embed)\/([\w-]{12,})/i;

const CHIP =
  'inline-flex items-center gap-xs rounded-full border border-white/[0.06] bg-surface px-sm py-1 text-[12px] text-text-secondary';
const URL = 'max-w-[20rem] truncate';

export function detectProvider(url: string): 'youtube' | 'loom' | null {
  if (YT_RX.test(url)) return 'youtube';
  if (LOOM_RX.test(url)) return 'loom';
  return null;
}

function Icon({ provider }: { provider: 'youtube' | 'loom' }): ReactNode {
  return provider === 'youtube' ? <Youtube size={12} /> : <Video size={12} />;
}

export function EmbedChip({
  url,
  onRemove,
}: {
  url: string;
  onRemove: () => void;
}): ReactNode {
  const provider = detectProvider(url) ?? 'loom';
  return (
    <span className={CHIP}>
      <Icon provider={provider} />
      <span className={URL}>{url}</span>
      <button
        onClick={onRemove}
        className="text-text-tertiary hover:text-error"
        aria-label="Quitar"
      >
        <X size={12} />
      </button>
    </span>
  );
}
